var _style, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStorysetEatingHealthyFood31398(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-eating-healthy-food",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "svg#freepik_stories-eating-healthy-food:not(.animated) .animable {opacity:\n        0;}svg#freepik_stories-eating-healthy-food.animated #freepik--Character--inject-2 {animation: 1s 1 forwards\n        cubic-bezier(.36,-0.01,.5,1.38) slideDown,1.5s Infinite linear floating;animation-delay:\n        0s,1s;}svg#freepik_stories-eating-healthy-food.animated #freepik--Table--inject-2 {animation: 1s 1 forwards\n        cubic-bezier(.36,-0.01,.5,1.38) slideDown;animation-delay: 0s;} @keyframes slideDown { 0% { opacity: 0;\n        transform: translateY(-30px); } 100% { opacity: 1; transform: translateY(0); } } @keyframes floating { 0% {\n        opacity: 1; transform: translateY(0px); } 50% { transform: translateY(-10px); } 100% { opacity: 1; transform:\n        translateY(0px); } }\n    ")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-2",
    className: "animable",
    style: {
      transformOrigin: "250px 228.23px"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "250px 382.525px"
    },
    id: "elup357o6j0hf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "433.34px 398.615px"
    },
    id: "el4dpvdw2c7ze",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "326.875px 401.335px"
    },
    id: "elzr307nudhx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "406.185px 389.335px"
    },
    id: "elnqw2h4md5j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "74.055px 391.015px"
    },
    id: "elyw41tycfuq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "107.725px 391.015px"
    },
    id: "elf7rb4dyz8mc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "178.31px 395.235px"
    },
    id: "elqbuy5envmk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "140.46px 196.4px"
    },
    id: "elljc1l85goc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "356.75px 196.4px"
    },
    id: "el24dags6rg3v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.6,251.16h8.7c-.06-6,0-21.29.61-56.3C372,131.41,374,127.54,374,127.54l-10.33,31.32a85,85,0,0,0-4.24,22.78C358.33,206.06,362.6,225.55,361.6,251.16Z",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "366.624px 189.35px"
    },
    id: "elygmm504oyi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355,149.42c-11.59-17.55-34.74-26.71-58.4-35.33-9.29-3.39,16.78,38.61,35.73,57.64,14.73,14.79,29,14.46,33.24,29.08C366.39,183.84,365,164.54,355,149.42Z",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "330.214px 157.353px"
    },
    id: "ell1gjabv2udm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.28,138.15c9.09-20.52,32.06-47.14,57.87-65.89,10.14-7.36-14.87,55.83-32.51,81.73-13.73,20.16-26.54,32.43-28.54,46.82C356.44,182.81,359.2,158.67,368.28,138.15Z",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "394.173px 136.239px"
    },
    id: "elxm9olh8xbsn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.42,270.14h0A19.26,19.26,0,0,1,348.2,252l-1.7-17.41h41.84L386.64,252A19.24,19.24,0,0,1,367.42,270.14Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "367.42px 252.365px"
    },
    id: "elm4qt070862j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "391.05 234.69 343.79 234.69 342.44 228.5 392.4 228.5 391.05 234.69",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "367.42px 231.595px"
    },
    id: "el96pcn105t6r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "388.72 245.29 346.12 245.29 344.9 239.11 389.94 239.11 388.72 245.29",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "367.42px 242.2px"
    },
    id: "el77gmneayqdo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eldkcqnl1tu"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.74,
    y: 83.78,
    width: 222.35,
    height: 141.9,
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "187.915px 154.73px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "elw6pniifka5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elocem9kzvpxm"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 71.3,
    y: 83.78,
    width: 225.25,
    height: 141.9,
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "183.925px 154.73px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "elnq0dd3vgiz"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el71hsjeyz5mw"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.74,
    y: 225.68,
    width: 222.35,
    height: 10.11,
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "187.915px 230.735px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "el9c5ue0bojav"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M67.29,225.68H282.43a5,5,0,0,1,5.05,5h0a5.05,5.05,0,0,1-5.05,5.06H67.29a5.06,5.06,0,0,1-5.06-5.06h0A5.06,5.06,0,0,1,67.29,225.68Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "174.855px 230.71px"
    },
    id: "elfucbvfgr6ht",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eltjhjn4ymmq"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 120.59,
    y: 49.72,
    width: 126.66,
    height: 210.01,
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "183.92px 154.725px",
      transform: "rotate(90deg)"
    },
    className: "animable",
    id: "el6ev0t9gupab"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "274.36 218.06 229.65 91.4 208.54 91.4 253.25 218.06 274.36 218.06",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "241.45px 154.73px"
    },
    id: "elpa56zwlunqo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.41,175.09a.55.55,0,0,1-.55-.55V96.36a.55.55,0,1,1,1.09,0v78.18A.55.55,0,0,1,285.41,175.09Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "285.405px 135.413px"
    },
    id: "elc8xecxrngr6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "248.72 218.06 204.01 91.4 195.78 91.4 240.49 218.06 248.72 218.06",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "222.25px 154.73px"
    },
    id: "el15r9mfk93jg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.46 218.06 158.75 91.4 137.65 91.4 182.35 218.06 203.46 218.06",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "170.555px 154.73px"
    },
    id: "elk7lhwuh5op",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.36 218.06 102.65 91.4 94.42 91.4 139.13 218.06 147.36 218.06",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "120.89px 154.73px"
    },
    id: "eljgfw2dfwcz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el8g783qvntw8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16.07,
    y: 154.25,
    width: 126.66,
    height: 0.97,
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "79.4px 154.735px",
      transform: "rotate(90deg)"
    },
    className: "animable",
    id: "el5v5ipc0gr3t"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elrhbjeqmpnk"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "69.5 104.01 291.85 104.01 292.55 94.36 70.2 94.36 69.5 104.01",
    style: {
      fill: "rgb(230, 230, 230)",
      opacity: 0.4,
      transformOrigin: "181.025px 99.185px"
    },
    className: "animable",
    id: "el4akoytixdt2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el3wmojhy5b7q"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "69.5 111.08 291.85 111.08 292.55 101.42 70.2 101.42 69.5 111.08",
    style: {
      fill: "rgb(230, 230, 230)",
      opacity: 0.4,
      transformOrigin: "181.025px 106.25px"
    },
    className: "animable",
    id: "el8dkyuam7s8w"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elfu74t0qemwj"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "69.5 119.55 291.85 119.55 292.55 109.9 70.2 109.9 69.5 119.55",
    style: {
      fill: "rgb(230, 230, 230)",
      opacity: 0.4,
      transformOrigin: "181.025px 114.725px"
    },
    className: "animable",
    id: "elsltw49my1u"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elv91j8xzpj8f"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "69.5 128.98 291.85 128.98 292.55 119.33 70.2 119.33 69.5 128.98",
    style: {
      fill: "rgb(230, 230, 230)",
      opacity: 0.4,
      transformOrigin: "181.025px 124.155px"
    },
    className: "animable",
    id: "eln7wjj50v83g"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eljpjwlmlu8rg"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "69.5 140.29 291.85 140.29 292.55 130.63 70.2 130.63 69.5 140.29",
    style: {
      fill: "rgb(230, 230, 230)",
      opacity: 0.4,
      transformOrigin: "181.025px 135.46px"
    },
    className: "animable",
    id: "el5wpze7t2kw4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elz1pxtr3n4g"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "69.5 153 291.85 153 292.55 143.35 70.2 143.35 69.5 153",
    style: {
      fill: "rgb(230, 230, 230)",
      opacity: 0.4,
      transformOrigin: "181.025px 148.175px"
    },
    className: "animable",
    id: "elbnf4g95wjn"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elye1tlf4jig"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 86.38,
    cy: 348.47,
    r: 33.92,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "86.38px 348.47px",
      transform: "rotate(-8.92deg)"
    },
    className: "animable",
    id: "ellqe6tomw0pc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el5ga557bzfh2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.46,322.38c-2.91-.12-5.21-1.37-5.15-2.8s2.46-2.47,5.37-2.35,5.21,1.38,5.15,2.8S87.37,322.5,84.46,322.38Z",
    style: {
      fill: "rgb(230, 230, 230)",
      opacity: 0.7,
      mixBlendMode: "multiply",
      transformOrigin: "84.57px 319.805px"
    },
    className: "animable",
    id: "elmnv5nmd757k"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el4m73q3fynzr"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.87,327.5c-2.44,1.57-5.05,1.87-5.82.68s.59-3.45,3-5,5-1.88,5.82-.68S72.32,325.92,69.87,327.5Z",
    style: {
      fill: "rgb(230, 230, 230)",
      opacity: 0.7,
      mixBlendMode: "multiply",
      transformOrigin: "68.4713px 325.341px"
    },
    className: "animable",
    id: "elhjt5sgex5ks"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elhehgg60huds"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.14,334.07c-2.66,1.2-5.4.85-6.13-.78s.82-3.92,3.47-5.11,5.39-.85,6.13.78S82.79,332.87,80.14,334.07Z",
    style: {
      fill: "rgb(230, 230, 230)",
      opacity: 0.7,
      mixBlendMode: "multiply",
      transformOrigin: "78.8117px 331.127px"
    },
    className: "animable",
    id: "el7du8rnsyp7k"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elua3kc6ed7zl"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 128.32,
    y: 270.14,
    width: 42.13,
    height: 112.26,
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "149.385px 326.27px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "el6sv00ih90tw"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "136.33 382.4 128.32 382.4 128.32 352.73 144.72 352.73 136.33 382.4",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "136.52px 367.565px"
    },
    id: "el9tn845ll4ym",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elc92khbc6338"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 368.71,
    y: 270.14,
    width: 42.13,
    height: 112.26,
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "389.775px 326.27px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "el15t54gpnnw5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elb0jv4fymdyk"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 128.32,
    y: 270.14,
    width: 247.37,
    height: 104.16,
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "252.005px 322.22px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "el0zdhyh7auqd"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "367.69 382.4 375.69 382.4 375.69 352.73 359.3 352.73 367.69 382.4",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "367.495px 367.565px"
    },
    id: "elt1jya9e01ej",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.24,361.76H293.36V281.62h74.88Zm-73.33-1.55h71.78v-77H294.91Z",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "330.8px 321.69px"
    },
    id: "elv84bmrjuta",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.45,361.76H214.57V281.62h74.88Zm-73.33-1.55H287.9v-77H216.12Z",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "252.01px 321.69px"
    },
    id: "el0j02sh7u1xon",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.65,361.76H135.77V281.62h74.88Zm-73.33-1.55H209.1v-77H137.32Z",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "173.21px 321.69px"
    },
    id: "elfnzn51axwph",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-2",
    className: "animable",
    style: {
      transformOrigin: "250px 416.24px"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-2",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "250px 416.24px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2",
    className: "animable",
    style: {
      transformOrigin: "238.433px 254.671px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.29,115.45c-15-5.77-30.21,8.66-29,35.45.91,20-18.22,17.82-8.22,35.63s2.59,29.86-8,26.62c8,10.08,31.63,2.3,31.7-14.14s40.52,7.55,40.52,7.55S277.08,221,300,217.65s42.81-49.44,42.89-69.91c.06-13.57-14.44-19.84-21.77-18.51C320.85,111.9,251.29,79.68,258.29,115.45Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "277.98px 158.713px"
    },
    id: "el0d7plnscdium",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.09,212.35A14.36,14.36,0,0,1,212,211l.45-.89s4.6,2.3,9,.71c2.66-1,4.73-3.16,6.16-6.53l.92.39c-1.54,3.64-3.81,6-6.75,7.08A10.78,10.78,0,0,1,218.09,212.35Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "220.265px 208.321px"
    },
    id: "eladtdg1ixcg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.39,173.42l-.78-.62c5.53-6.89,4.93-13.17,4.23-20.44-.63-6.62-1.35-14.13,2.7-23.29,4.55-10.28,10.7-16.39,17.79-17.67,5.92-1.08,12.2,1.42,17.69,7l-.71.7c-5.25-5.36-11.22-7.76-16.8-6.75-6.75,1.22-12.65,7.14-17,17.1-4,8.92-3.24,16.28-2.62,22.78C227.52,159.44,228.17,166.22,222.39,173.42Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "242.815px 142.287px"
    },
    id: "elnqrv0wki8hq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.29,283.57l-3.71-11.44a16.62,16.62,0,0,0-5.27-7.73l-4.3-3.54a7.82,7.82,0,0,0-8.78,1.44l-6.79,6.52a7.85,7.85,0,0,0-.64,10.63l2.91,3.55s8.76,13.56,19.94,17.86l2.24-2.47A17.92,17.92,0,0,0,140.29,283.57Z",
    style: {
      fill: "rgb(255, 139, 123)",
      transformOrigin: "124.77px 280.483px"
    },
    id: "el5gasajglsz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.2,275.69l-.56,1.65-.51,1.46-1,2.85c-.69,1.89-1.44,3.72-2.18,5.55-1.49,3.67-3.11,7.25-4.79,10.81s-3.46,7.07-5.33,10.55-3.78,6.92-5.87,10.3a201,201,0,0,1-13.59,19.72,154.21,154.21,0,0,1-16.5,18.1c-.76.7-1.51,1.41-2.29,2.1l-2.37,2.05-.59.51-.3.26-.73.61a21.42,21.42,0,0,1-4.38,2.73,19.84,19.84,0,0,1-5.51,1.64,20.15,20.15,0,0,1-5.42.05,22.38,22.38,0,0,1-7.71-2.47,27.42,27.42,0,0,1-4.61-3.12,41.93,41.93,0,0,1-5.77-5.86,82.59,82.59,0,0,1-7.42-10.88c-2.05-3.57-3.86-7.11-5.57-10.64-3.36-7.09-6.26-14.17-8.85-21.33s-4.91-14.31-6.86-21.8A8.5,8.5,0,0,1,140.94,284l.1.17c7.49,12.36,14.91,25.08,22.8,36.58,1.95,2.88,3.95,5.67,6,8.24a61.94,61.94,0,0,0,5.94,6.77,11.15,11.15,0,0,0,2.26,1.74c.22.11.31,0,0-.13a6.09,6.09,0,0,0-2.46-.81,9.86,9.86,0,0,0-2.66,0,10.62,10.62,0,0,0-2.88.82,10.15,10.15,0,0,0-2.06,1.23l-.18.15-.08.06.05-.05.21-.22.43-.43,1.69-1.72,1.64-1.78A151.25,151.25,0,0,0,184,319.08c3.77-5.55,7.4-11.28,10.7-17.28s6.43-12.12,9.35-18.36c1.46-3.13,2.84-6.28,4.19-9.43l2-4.72.93-2.33.8-2.09.26-.68a17,17,0,0,1,32,11.5Z",
    style: {
      fill: "rgb(255, 139, 123)",
      transformOrigin: "185.243px 309.864px"
    },
    id: "ell9prvzlvcq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.85,279.79c.43,9.86-15.13,32.65,4.08,45.86,2.26,19.91,5.09,39.51,10.4,72.16H322.57c-4.12-28.24-3.22-60.42,10-124a25.33,25.33,0,0,0-22.26-30.39c-4-.4-8.24-.74-12.58-1-16.86-.81-30.69-1.35-45.52,0-4.91.45-10,1.07-14.84,1.75A34.41,34.41,0,0,0,207.85,279.79Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "267.707px 319.704px"
    },
    id: "elvlwtkxfgqk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(&quot",
      transformOrigin: "268.692px 316.631px"
    },
    id: "el8rr4lqb6jzf",
    className: "animable"
  }, /*#__PURE__*/React.createElement("g", {
    id: "elxm50j7ofttp"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.51,266.53c4.65,4.86,11.58,6.69,15,5.18s-.72-3.09-4.41-3.28,2.15-1.59,8.38-.91,5.69-3.72-1-4.87.1-1.67,5.65-1.27,6.17-3.57-.53-5,12.33-.42,6-7-9.63,8.83-9.66,3.2-4.9-6.12-5.79-1.63-3.17,9.7-2.9,4.14-4.83-7.05-5.55-2-3.82,9.36-3.14,6.39-.18-6.6-2.82-4.28S202.87,261.67,207.51,266.53Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "221.151px 259.969px"
    },
    className: "animable",
    id: "elbk575uhmuh"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el64plndhhr74"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M260.53,272.66c-4.7-4.81-11.65-6.57-15-5s.74,3.07,4.44,3.23-2.14,1.61-8.37,1-5.66,3.78,1,4.85-.08,1.68-5.64,1.34-6.13,3.63.58,5-12.32.55-5.93,7.1,9.54-8.94,9.62-3.31,5,6.07,5.81,1.57,3.07-9.73,2.86-4.17,4.91,7,5.57,1.91,3.72-9.4,3.08-6.43.24,6.61,2.86,4.26S265.22,277.47,260.53,272.66Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "246.995px 279.464px"
    },
    className: "animable",
    id: "elpehib0kedcn"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ellxmedkhtjur"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193.8,298.08c4.65,4.86,11.59,6.7,15,5.18s-.71-3.08-4.41-3.27,2.15-1.59,8.38-.91,5.7-3.73-1-4.87.09-1.68,5.65-1.28,6.16-3.57-.53-5,12.32-.41,6-7-9.63,8.84-9.66,3.21-4.9-6.12-5.79-1.64-3.17,9.7-2.9,4.15-4.83-7.06-5.55-2-3.82,9.35-3.14,6.39-.18-6.61-2.82-4.28S189.16,293.23,193.8,298.08Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "207.44px 291.52px"
    },
    className: "animable",
    id: "elglg8mgy0xo7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elao1rrswlpjl"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246.82,304.21c-4.7-4.81-11.65-6.57-15-5s.75,3.08,4.44,3.23-2.13,1.61-8.37,1-5.65,3.78,1,4.86-.08,1.67-5.64,1.33-6.12,3.64.58,5-12.32.54-5.92,7.09,9.53-8.93,9.62-3.31,5,6.07,5.81,1.58,3.07-9.74,2.85-4.18,4.91,7,5.58,1.91,3.71-9.39,3.07-6.42.24,6.6,2.86,4.25S251.52,309,246.82,304.21Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "233.29px 311.009px"
    },
    className: "animable",
    id: "el6fxkt5dsesf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elz4ao395mp6s"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M277.07,275.64c4.64,4.86,11.58,6.69,15,5.18s-.71-3.09-4.4-3.28,2.15-1.59,8.37-.91,5.7-3.72-1-4.87.09-1.67,5.65-1.27,6.16-3.57-.53-5,12.33-.42,6-7-9.62,8.83-9.65,3.2-4.91-6.12-5.79-1.63-3.18,9.7-2.91,4.14-4.83-7.05-5.55-2-3.82,9.36-3.14,6.39-.17-6.6-2.82-4.28S272.42,270.78,277.07,275.64Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "290.708px 269.079px"
    },
    className: "animable",
    id: "el9i4xj3a30a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elmpr7coi3r8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M330.08,281.77c-4.69-4.81-11.65-6.57-15.05-5s.75,3.07,4.44,3.23-2.13,1.61-8.37,1-5.65,3.78,1,4.86-.08,1.67-5.63,1.33-6.13,3.63.58,5-12.32.54-5.93,7.09,9.53-8.94,9.62-3.31,5,6.07,5.81,1.57,3.07-9.73,2.86-4.17,4.9,7,5.57,1.91,3.72-9.39,3.07-6.42.25,6.6,2.86,4.25S334.78,286.58,330.08,281.77Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "316.513px 288.569px"
    },
    className: "animable",
    id: "elabskw4gl2m7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elvlilhftwve"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263.36,307.2c4.65,4.85,11.58,6.69,15,5.17s-.72-3.08-4.41-3.27,2.15-1.59,8.38-.91,5.69-3.72-1-4.87.1-1.68,5.65-1.28,6.17-3.56-.53-5,12.33-.41,6-7-9.63,8.84-9.66,3.21-4.9-6.12-5.79-1.64-3.17,9.7-2.9,4.15-4.83-7.06-5.56-2-3.81,9.35-3.14,6.39-.17-6.61-2.81-4.28S258.72,302.34,263.36,307.2Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "277.001px 300.63px"
    },
    className: "animable",
    id: "elypxy2nwhc6k"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el2d8anbhl4w5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.36,338.16c-4.7-4.81-11.65-6.57-15.05-5s.75,3.07,4.44,3.23-2.13,1.61-8.37,1-5.65,3.78,1,4.85-.08,1.68-5.64,1.34-6.12,3.63.58,5-12.32.55-5.92,7.1,9.53-8.94,9.62-3.31,5,6.07,5.8,1.57,3.08-9.73,2.86-4.17,4.91,7,5.58,1.91,3.71-9.4,3.07-6.43.24,6.61,2.86,4.26S237.06,343,232.36,338.16Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "218.793px 344.964px"
    },
    className: "animable",
    id: "elel2ih7vzmfp"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ele0tpfkw819m"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M218.65,369.71c-4.69-4.81-11.65-6.57-15.05-5s.75,3.08,4.44,3.23-2.13,1.61-8.36,1-5.66,3.78,1,4.86-.07,1.67-5.63,1.33-6.13,3.64.58,5-12.32.54-5.93,7.09,9.53-8.93,9.62-3.31,5,6.07,5.81,1.58,3.07-9.74,2.86-4.18,4.9,7,5.57,1.91,3.72-9.39,3.07-6.42.25,6.6,2.87,4.25S223.35,374.52,218.65,369.71Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "205.095px 376.509px"
    },
    className: "animable",
    id: "elljlgbf0obl"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el6kgdpfejnb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M248.9,341.14c4.64,4.86,11.58,6.69,15,5.18s-.72-3.09-4.41-3.28,2.15-1.59,8.38-.91,5.69-3.72-1-4.87.1-1.67,5.65-1.27,6.17-3.57-.53-5,12.33-.42,6-7-9.63,8.83-9.66,3.2-4.9-6.12-5.79-1.63-3.18,9.7-2.9,4.14-4.83-7.05-5.56-2-3.81,9.36-3.14,6.39-.17-6.6-2.81-4.28S244.25,336.28,248.9,341.14Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "262.539px 334.579px"
    },
    className: "animable",
    id: "eltetljps9ong"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elqqlrgfe0ag"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.19,372.7c4.65,4.85,11.58,6.69,15,5.17s-.71-3.08-4.41-3.27,2.15-1.59,8.38-.91,5.69-3.72-1-4.87.09-1.68,5.65-1.28,6.16-3.56-.53-5,12.32-.41,6-7-9.63,8.84-9.66,3.21-4.9-6.12-5.79-1.64-3.17,9.7-2.9,4.15-4.83-7.06-5.55-2-3.82,9.35-3.14,6.39-.18-6.61-2.82-4.28S230.55,367.84,235.19,372.7Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "248.83px 366.13px"
    },
    className: "animable",
    id: "elpj0yd5eq2zs"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elcbuaj4laf84"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M302.08,348.49c-4.69-4.81-11.65-6.57-15.05-5s.75,3.08,4.44,3.23-2.13,1.61-8.37,1-5.65,3.78,1,4.86-.07,1.67-5.63,1.33-6.13,3.63.58,5-12.32.54-5.93,7.09,9.53-8.94,9.62-3.31,5,6.07,5.81,1.58,3.07-9.74,2.86-4.18,4.9,7,5.57,1.91,3.72-9.39,3.07-6.42.25,6.6,2.87,4.25S306.78,353.3,302.08,348.49Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "288.517px 355.289px"
    },
    className: "animable",
    id: "el1al9l6v4fc9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elqx1nr03vfbd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M288.38,380.05c-4.7-4.81-11.65-6.57-15.05-5s.74,3.07,4.44,3.23-2.14,1.61-8.37,1-5.65,3.78,1,4.85-.08,1.68-5.64,1.34-6.13,3.63.58,5-12.32.55-5.93,7.09,9.54-8.93,9.63-3.3,5,6.07,5.8,1.57,3.07-9.73,2.86-4.18,4.91,7,5.57,1.92,3.72-9.4,3.08-6.43.24,6.61,2.86,4.26S293.07,384.85,288.38,380.05Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "274.808px 386.847px"
    },
    className: "animable",
    id: "elaa3ps5ut36k"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elwddkvk59nq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M318.62,351.47c4.65,4.86,11.58,6.7,15,5.18s-.71-3.08-4.41-3.27,2.15-1.59,8.38-.92,5.69-3.72-1-4.86.09-1.68,5.65-1.28,6.16-3.57-.53-5,12.32-.41,6-7-9.63,8.83-9.66,3.21-4.9-6.12-5.79-1.64-3.17,9.7-2.9,4.15-4.83-7.06-5.55-2-3.82,9.35-3.14,6.39-.18-6.61-2.82-4.28S314,346.61,318.62,351.47Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "332.264px 344.91px"
    },
    className: "animable",
    id: "elmtpmp2u197"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elomkobn5cj49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M218.46,404.38c4.64,4.86,11.58,6.69,15,5.17s-.71-3.08-4.4-3.27,2.15-1.59,8.38-.91,5.69-3.72-1-4.87.09-1.67,5.65-1.27,6.16-3.57-.53-5,12.33-.41,6-7-9.62,8.83-9.65,3.2-4.91-6.12-5.79-1.64-3.18,9.71-2.91,4.15-4.83-7.05-5.55-2-3.82,9.35-3.14,6.39-.17-6.6-2.82-4.28S213.81,399.52,218.46,404.38Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "232.105px 397.815px"
    },
    className: "animable",
    id: "elmj3dgh60wu9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ely2iylffu5yi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M304.92,383c4.64,4.86,11.58,6.69,15,5.18s-.71-3.09-4.4-3.28,2.15-1.59,8.38-.91,5.69-3.72-1-4.87.09-1.67,5.65-1.27,6.16-3.57-.53-5,12.33-.42,6-7-9.62,8.83-9.65,3.2-4.91-6.12-5.79-1.63-3.18,9.7-2.91,4.14-4.83-7-5.55-2S306.3,379,307,376s-.17-6.6-2.82-4.28S300.27,378.17,304.92,383Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "318.57px 376.439px"
    },
    className: "animable",
    id: "el3twu7k52hm"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el000u3ukxauopp"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M316.38,313.32c-4.7-4.81-11.65-6.57-15.05-5s.74,3.07,4.44,3.22-2.14,1.61-8.37,1-5.66,3.78,1,4.86-.07,1.68-5.63,1.33-6.13,3.64.58,5-12.32.54-5.93,7.09,9.54-8.93,9.62-3.31,5,6.07,5.81,1.58,3.07-9.73,2.86-4.18,4.9,7,5.57,1.92,3.72-9.4,3.08-6.43.24,6.61,2.86,4.25S321.07,318.13,316.38,313.32Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "302.815px 320.114px"
    },
    className: "animable",
    id: "elkt6vjnbps3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elzjijbc72hu"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M319.21,228.75c-4.7-4.81-11.65-6.57-15-5s.74,3.07,4.44,3.23-2.13,1.61-8.37,1-5.65,3.78,1,4.86-.08,1.67-5.64,1.33-6.12,3.63.58,5-12.32.54-5.92,7.09,9.53-8.94,9.62-3.31,5,6.07,5.8,1.57,3.08-9.73,2.86-4.17,4.91,7,5.58,1.91,3.71-9.39,3.07-6.42.24,6.6,2.86,4.25S323.9,233.56,319.21,228.75Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "305.678px 235.549px"
    },
    className: "animable",
    id: "elnhbe24lhayd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "eldobudhm6baj"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M309.72,268.88c-1.79,14.81,4.52,41.26,13.23,61.05,1.52-12.37,3.79-26.39,6.94-42.63Z",
    style: {
      opacity: 0.2,
      transformOrigin: "319.653px 299.405px"
    },
    className: "animable",
    id: "el6kadt77p3dk"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M302.4,242.78c-1.52-.1-3.07-.19-4.63-.27-16.86-.82-30.69-1.35-45.52,0l-3.88.39a35.39,35.39,0,0,0-1,36l2,3.74,2.85-3.15C272.6,257,298.13,245,298.39,244.85l4-2.07Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "272.667px 262.162px"
    },
    id: "eldj725a0vt8u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.26,191.26c-2.87,14.64-5.73,41.48,4.51,51.25,0,0-26.69,11.66-47.77,34.95-10.3-19.11,2.25-34.95,2.25-34.95,16.34-3.9,15.91-16,13.07-27.4Z",
    style: {
      fill: "rgb(255, 139, 123)",
      transformOrigin: "271.855px 234.36px"
    },
    id: "elnhggrbtnvdq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elv5gvpc5w7a9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M281.87,201,265.33,215.1a46.42,46.42,0,0,1,1.41,8.08c6.24-.9,14.81-7.75,15.47-14.28A22,22,0,0,0,281.87,201Z",
    style: {
      opacity: 0.2,
      transformOrigin: "273.874px 212.09px"
    },
    className: "animable",
    id: "elcmic4sbsqq5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M308.71,164.39c-5.71,23.82-7.63,34-21.75,44.27-21.23,15.41-48.65,3.25-50-21.78-1.24-22.53,8.31-57.7,33.12-63.19C294.49,118.28,314.43,140.57,308.71,164.39Z",
    style: {
      fill: "rgb(255, 139, 123)",
      transformOrigin: "273.276px 169.177px"
    },
    id: "ellwbtp4pv4v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.78,134.44C287,154.78,263.83,121.18,250,137.73c-8-7.12,14.54-25.45,28.1-26.12S321.05,120.28,310.78,134.44Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "280.62px 126.392px"
    },
    id: "elcobv92le29k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.1,134.33s-2.54-7.05-1.1-11.46c-3.78,1.57-5.09,14.29-3,14.86C252.92,138.53,254.1,134.33,254.1,134.33Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "251.554px 130.351px"
    },
    id: "elsfjv5wffpbr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.11,132.5c-24.89,9.11-13.86,57,7.55,54.09S332.56,136.94,307.11,132.5Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "310.774px 159.609px"
    },
    id: "elye2pt3xvjk8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.4,164.65c-.34,2-1.66,3.37-2.94,3.14s-2-2-1.7-4,1.67-3.37,2.95-3.14S273.75,162.69,273.4,164.65Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "271.089px 164.22px"
    },
    id: "elg2f55jic8i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.23,160.73c-.34,2-1.66,3.36-2.94,3.13s-2-2-1.7-4,1.67-3.36,2.95-3.14S249.58,158.77,249.23,160.73Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "246.919px 160.291px"
    },
    id: "elv94ni3ozi1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.09,157l-4.47-2.19S245.39,158.89,248.09,157Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "245.855px 156.155px"
    },
    id: "el6wtzg5z1249",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.39,165.13s-4.83,7.85-9.21,11.28c2.16,2.87,6.76,2.54,6.76,2.54Z",
    style: {
      fill: "rgb(255, 86, 82)",
      transformOrigin: "250.785px 172.046px"
    },
    id: "elinfej21ic3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.93,188.2a20,20,0,0,1-3.34-.3.58.58,0,0,1-.47-.68.57.57,0,0,1,.67-.47,15.79,15.79,0,0,0,13.74-3.83.59.59,0,0,1,.83,0,.59.59,0,0,1,0,.83A16.34,16.34,0,0,1,262.93,188.2Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "266.82px 185.475px"
    },
    id: "el04zhmo3c3jwm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.37,187.55a16.3,16.3,0,0,1-12.31,5.28c-5.84-.31-6.51-7.06-3-12.49,3.15-4.89,10-10.62,14.94-7.65S314.6,183.13,310.37,187.55Z",
    style: {
      fill: "rgb(255, 139, 123)",
      transformOrigin: "303.271px 182.353px"
    },
    id: "elm8funab6o1h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.86,186.44a14.27,14.27,0,0,1,3.86-11,4,4,0,0,0-2.46,1.22,12.31,12.31,0,0,0-3.39,9.51c.22,3.54,2.65,6.74,5.64,7.46A10.16,10.16,0,0,1,274.86,186.44Z",
    style: {
      fill: "rgb(255, 139, 123)",
      transformOrigin: "275.775px 184.535px"
    },
    id: "el5ybbes3bde",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elsuby1xv6py"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M274.86,186.44a14.27,14.27,0,0,1,3.86-11,4,4,0,0,0-2.46,1.22,12.31,12.31,0,0,0-3.39,9.51c.22,3.54,2.65,6.74,5.64,7.46A10.16,10.16,0,0,1,274.86,186.44Z",
    style: {
      opacity: 0.2,
      transformOrigin: "275.775px 184.535px"
    },
    className: "animable",
    id: "elh1ayamu7cem"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M281.4,156.74a1.2,1.2,0,0,1-.69-.62,9.29,9.29,0,0,0-6.45-5.44,1.17,1.17,0,1,1,.35-2.32,11.61,11.61,0,0,1,8.23,6.79,1.17,1.17,0,0,1-1.44,1.59Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "278.103px 152.574px"
    },
    id: "elcvigodw5jrc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.32,149.83a1.19,1.19,0,0,1-.83-.27,1.16,1.16,0,0,1-.14-1.64,11.57,11.57,0,0,1,9.73-4.37,1.17,1.17,0,0,1,1,1.29,1.18,1.18,0,0,1-1.3,1,9.25,9.25,0,0,0-7.67,3.54A1.14,1.14,0,0,1,241.32,149.83Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "245.581px 146.682px"
    },
    id: "elin25pz4zxl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.26,160.9l-4.47-2.19S269.56,162.81,272.26,160.9Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "270.025px 160.059px"
    },
    id: "elh3f0i3ilaib",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.2,394.19a17.89,17.89,0,0,0-9.73-12L272.41,377a11,11,0,0,0-10.22.44l-5,2.9a7.85,7.85,0,0,0-3.78,8.06l1.54,9.29a7.86,7.86,0,0,0,8.41,6.53l4.57-.39s16.13.44,26-6.35Z",
    style: {
      fill: "rgb(255, 139, 123)",
      transformOrigin: "273.617px 390.099px"
    },
    id: "el81mnwv9l9xr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.87,254.83l1,1.37.91,1.23,1.74,2.41c1.15,1.6,2.22,3.22,3.3,4.84,2.15,3.23,4.16,6.52,6.12,9.86s3.81,6.71,5.59,10.15,3.5,6.91,5.09,10.46a176.62,176.62,0,0,1,14,45.28c.26,2,.6,4,.78,6.07l.31,3.06.05.57.05,1a17,17,0,0,1,0,2c0,.66-.08,1.34-.16,2s-.21,1.25-.33,1.87a25.57,25.57,0,0,1-2.27,6.26,29.31,29.31,0,0,1-2.9,4.49,40.2,40.2,0,0,1-5.94,6,70.13,70.13,0,0,1-11.25,7.4c-3.68,1.94-7.31,3.58-10.93,5.09s-7.24,2.78-10.85,4-7.24,2.29-10.86,3.29-7.27,1.89-10.92,2.73c-1.83.4-3.66.77-5.5,1.14s-3.66.65-5.62,1a8.49,8.49,0,0,1-5.21-16l.32-.15c12.55-6.24,25.5-12.54,36.9-19.52,2.85-1.73,5.58-3.53,8.05-5.37a42.53,42.53,0,0,0,6.27-5.35,7.41,7.41,0,0,0,1.39-1.95c.21-.39-.2-.27-.56,1a3.37,3.37,0,0,0-.12.53c0,.2-.07.42-.08.63s0,.44,0,.67,0,.23,0,.34v.09s0,0,0,0l0-.15-.43-2.31c-.26-1.54-.66-3.09-1-4.63a172.92,172.92,0,0,0-13.78-36.63c-2.94-6-6.23-11.88-9.64-17.68-1.72-2.9-3.51-5.75-5.3-8.58l-2.74-4.17-1.36-2-1.24-1.79-.42-.6a17,17,0,0,1,27.5-20Z",
    style: {
      fill: "rgb(255, 139, 123)",
      transformOrigin: "324.053px 323.158px"
    },
    id: "eljmr1u59v2zc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.32,226.72a1.09,1.09,0,0,0-1.12,1l-.54,12.46a1.2,1.2,0,0,1-1.65,1.06l-2-.83a1.21,1.21,0,0,1-.74-1.16l.55-12.79a1.08,1.08,0,1,0-2.15-.1l-.55,12.8a1.2,1.2,0,0,1-.84,1.09l-2.07.65a1.2,1.2,0,0,1-1.56-1.19l.54-12.46a1.08,1.08,0,0,0-2.16-.09l-.61,14.16a7.69,7.69,0,0,0,3.88,7,3.66,3.66,0,0,1,1.82,3.55c-.8,7.9-2.73,26.8-4.25,39.56-2,16.47.54,19.44,3.23,19.56s5.46-2.63,4.91-19.21c-.42-12.84-.72-31.84-.84-39.78a3.66,3.66,0,0,1,2.12-3.38,7.69,7.69,0,0,0,4.47-6.64l.61-14.16A1.09,1.09,0,0,0,136.32,226.72Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "129.392px 268.116px"
    },
    id: "el68uesan2659",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.42,212.66c-3.7,11.56,13.48,28.18,27.59,18.93C135.59,223.2,118.42,212.66,118.42,212.66Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "131.96px 223.472px"
    },
    id: "elcy4i581ii57",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el3e629b3eb13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.62,214.66c-2,8.78,10.49,20.65,21.09,14.37C135.4,223.51,126.34,217.65,121.62,214.66Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "132.059px 222.725px"
    },
    className: "animable",
    id: "el33y1vl6kyke"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-2",
    className: "animable",
    style: {
      transformOrigin: "250px 369.74px"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 56.11,
    y: 395.26,
    width: 387.78,
    height: 12.67,
    style: {
      fill: "#1AB1AD",
      transformOrigin: "250px 401.595px"
    },
    id: "el9mmw35owukk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elhm6pmtxeetc"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 56.11,
    y: 400.88,
    width: 387.78,
    height: 1.43,
    style: {
      opacity: 0.2,
      transformOrigin: "250px 401.595px"
    },
    className: "animable",
    id: "elqihccwl7gqs"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "428.33 412.88 71.67 412.88 61.67 407.93 438.33 407.93 428.33 412.88",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "250px 410.405px"
    },
    id: "elbwvd6fv4j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el0aelfzsj17o"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "428.33 412.88 71.67 412.88 61.67 407.93 438.33 407.93 428.33 412.88",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "250px 410.405px"
    },
    className: "animable",
    id: "elvy80dc2r0af"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M124.34,360.35c-3.46-3.21-13.76,2-13.14-4.54s-6.32-1.8-7.28-8.2,8.35-4.54,4.41-9.5-.8-11.44,5.24-11.51,4.33,7.69,9.53,4.17c5.72-3.87,10.44-.45,10.46,4.71s4.79,2.25,6.72,7.66c2.54,7.12-9.11,7.89-6.8,12.12S130.05,365.63,124.34,360.35Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "122.247px 344.496px"
    },
    id: "elcreexepod0m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el5sg6l2m0xar"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.34,360.35c-3.46-3.21-13.76,2-13.14-4.54s-6.32-1.8-7.28-8.2,8.35-4.54,4.41-9.5-.8-11.44,5.24-11.51,4.33,7.69,9.53,4.17c5.72-3.87,10.44-.45,10.46,4.71s4.79,2.25,6.72,7.66c2.54,7.12-9.11,7.89-6.8,12.12S130.05,365.63,124.34,360.35Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      transformOrigin: "122.247px 344.496px"
    },
    className: "animable",
    id: "el49amq71k4e6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M123.72,357.76c-3.87-4.93-11.5,2.37-11-3.16s-7-2.2-6.33-7.64,8.85-5.65,4.33-8.57-1.9-9.73,3.23-9.79,4.29,7.07,8.7,4.09c4.84-3.28,8.84-.38,8.86,4s4.49,2,6.89,6.28c4.16,7.34-9.84,6.17-6.23,11.19C134.58,357.46,128.71,364.11,123.72,357.76Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "122.764px 344.503px"
    },
    id: "elux75ixee41d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el3zhxcagmjh3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.35,356.26c-3.16-4.31-9.87,1.7-9.26-3s-5.89-2.07-5.18-6.69,7.69-4.57,3.93-7.18-1.35-8.35,3-8.26,3.45,6.15,7.3,3.73c4.22-2.66,7.55-.07,7.44,3.65s3.77,1.87,5.7,5.54c3.34,6.38-8.56,5-5.62,9.37C132.62,356.31,127.43,361.82,123.35,356.26Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      transformOrigin: "122.866px 344.888px"
    },
    className: "animable",
    id: "elfp6l23zsk8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M105.59,351.62c.48,9,8.85,26.73,29.67,20.58C134.08,359.91,123.58,351.85,105.59,351.62Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "120.425px 362.544px"
    },
    id: "eldmhtp922qy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elpj58hxnhry"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.59,351.62c.48,9,8.85,26.73,29.67,20.58C134.08,359.91,123.58,351.85,105.59,351.62Z",
    style: {
      opacity: 0.3,
      transformOrigin: "120.425px 362.544px"
    },
    className: "animable",
    id: "eldrv9myfz5uu"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M108.42,353.93a53.59,53.59,0,0,0,7.21,5.44c2.54,1.67,5.14,3.27,7.73,4.86s5.25,3.11,7.87,4.65l7.83,4.69h0a.4.4,0,0,1-.32.73,44.5,44.5,0,0,1-8.51-3.69c-2.7-1.48-5.32-3.09-7.92-4.73s-5.13-3.4-7.6-5.24c-1.24-.92-2.46-1.86-3.63-2.89a23.62,23.62,0,0,1-3.3-3.33.41.41,0,0,1,.07-.56.42.42,0,0,1,.53,0Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "123.484px 364.044px"
    },
    id: "elosxob36jnyb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.15,360.4h-.06a.39.39,0,0,1-.33-.45,8.61,8.61,0,0,0-.51-5.05.4.4,0,0,1,.16-.54.39.39,0,0,1,.54.16,9.12,9.12,0,0,1,.6,5.55A.41.41,0,0,1,115.15,360.4Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "114.97px 357.354px"
    },
    id: "elnpld99nuq4d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.47,367.34a.4.4,0,0,1,0-.8s4.82-.44,6.2-2.86a.4.4,0,1,1,.69.4c-1.59,2.78-6.61,3.24-6.82,3.26Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "117.752px 365.397px"
    },
    id: "elna83szxwhts",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.32,367.57A.39.39,0,0,1,126,367c1.63-3.05-1-7.19-1-7.24a.39.39,0,0,1,.12-.55.4.4,0,0,1,.55.12c.12.19,2.92,4.58,1.07,8A.38.38,0,0,1,126.32,367.57Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "126.152px 363.362px"
    },
    id: "el7urfd7mr245",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.08,371.74a.4.4,0,0,1-.4-.38.41.41,0,0,1,.38-.42,7.38,7.38,0,0,0,3.52-1.47.4.4,0,1,1,.47.65,8.17,8.17,0,0,1-4,1.62Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "128.949px 370.566px"
    },
    id: "elohtc7ynukw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.62,336.79c-12.32.59-36.68,11.95-28.4,40.52C154.06,375.76,165.18,361.43,165.62,336.79Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "150.58px 357.05px"
    },
    id: "elnv1x51xvlv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elcwqmlfhk4vq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.62,336.79c-12.32.59-36.68,11.95-28.4,40.52C154.06,375.76,165.18,361.43,165.62,336.79Z",
    style: {
      opacity: 0.3,
      transformOrigin: "150.58px 357.05px"
    },
    className: "animable",
    id: "el0k2bpa5ivhdi"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M162.44,340.65A69.6,69.6,0,0,0,155,350.5c-2.31,3.47-4.54,7-6.73,10.56s-4.29,7.16-6.42,10.75l-6.48,10.68v0a.55.55,0,0,1-.76.18.54.54,0,0,1-.24-.62,60.49,60.49,0,0,1,5.12-11.63c2-3.69,4.26-7.27,6.52-10.82s4.68-7,7.22-10.39c1.27-1.69,2.58-3.35,4-4.94a33.13,33.13,0,0,1,4.59-4.5.54.54,0,0,1,.76.1.55.55,0,0,1,0,.72Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "148.531px 361.205px"
    },
    id: "elem2op0srxi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.62,350.6a16.08,16.08,0,0,1-2.64-.23.54.54,0,1,1,.18-1.07,11.69,11.69,0,0,0,6.92-.67.55.55,0,0,1,.52,1A11.3,11.3,0,0,1,156.62,350.6Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "157.714px 349.587px"
    },
    id: "elsoq25lgy8fi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.72,358.33a.53.53,0,0,1-.27-.08c-3.8-2.18-4.4-9.07-4.43-9.36a.55.55,0,0,1,.5-.59.55.55,0,0,1,.59.5c0,.07.58,6.61,3.88,8.51a.54.54,0,0,1,.2.74A.53.53,0,0,1,148.72,358.33Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "146.641px 353.314px"
    },
    id: "elv9aukoaz9p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.59,366.44a7.64,7.64,0,0,1-3.68-.88.53.53,0,0,1-.22-.74.54.54,0,0,1,.74-.22c4.17,2.25,9.86-1.33,9.91-1.37a.55.55,0,0,1,.76.17.54.54,0,0,1-.17.75A15.43,15.43,0,0,1,147.59,366.44Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "149.402px 364.793px"
    },
    id: "el529inr7it1m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.55,371.78a.53.53,0,0,1-.44-.23,11.15,11.15,0,0,1-2.2-5.42.55.55,0,0,1,.52-.57.53.53,0,0,1,.57.51,10.24,10.24,0,0,0,2,4.84.54.54,0,0,1-.12.76A.56.56,0,0,1,140.55,371.78Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "139.508px 368.669px"
    },
    id: "el2snnbczatdf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124,353.46c10,9.5,35.42.2,33-18.78C143.23,341.16,124,353.46,124,353.46Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "140.581px 345.951px"
    },
    id: "el9ndlnua75du",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elqlauofcibs"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.6,351.19c8,6.4,26.26-.48,25.1-14.4C143.46,341.51,133,347.85,127.6,351.19Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "140.176px 345.194px"
    },
    className: "animable",
    id: "elxqcmhe7z6pi"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M150.22,389.23c-9.41,10-35.36,2.18-34-16.91C130.31,378,150.22,389.23,150.22,389.23Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "133.194px 382.958px"
    },
    id: "elebnd00rsyqc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eltvcpa7n9bs"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.48,387.16c-7.6,6.84-26.25,1-25.87-13C130.11,378.38,140.91,384.13,146.48,387.16Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "133.542px 382.092px"
    },
    className: "animable",
    id: "elxdxjwdapt6m"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M175.68,350.06c-2.94,2.27.5,10.05-4.84,9.13s-2,4.42-7.4,4.64S160.39,357.5,156,360s-9.53-.25-9.09-4.6,6.73-2.56,4.25-6.55c-2.72-4.4.5-7.54,4.76-7.19s2.27-3.28,6.9-4.27c6.1-1.32,5.77,7.12,9.46,5.77S180.53,346.34,175.68,350.06Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "162.334px 350.542px"
    },
    id: "el057ljzl3vkmj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elzeb64r8wkl"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.68,350.06c-2.94,2.27.5,10.05-4.84,9.13s-2,4.42-7.4,4.64S160.39,357.5,156,360s-9.53-.25-9.09-4.6,6.73-2.56,4.25-6.55c-2.72-4.4.5-7.54,4.76-7.19s2.27-3.28,6.9-4.27c6.1-1.32,5.77,7.12,9.46,5.77S180.53,346.34,175.68,350.06Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      transformOrigin: "162.334px 350.542px"
    },
    className: "animable",
    id: "el0nd6yki389jm"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M173.49,350.33c-4.4,2.42,1,8.44-3.53,7.66s-2.4,4.86-6.85,4-3.94-6.77-6.72-3.73-8.21.66-7.84-3,6.21-2.57,4.11-6c-2.3-3.73.43-6.39,4-6.09s2.06-3.08,5.77-4.5c6.42-2.46,4.29,7.52,8.74,5.29C174.15,342.49,179.16,347.19,173.49,350.33Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "162.301px 350.178px"
    },
    id: "elybwmyyn2st",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elobmhgb0pa2o"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.22,350.48c-3.83,2,.58,7.22-3.26,6.45s-2.2,4.08-6,3.24-3.14-5.87-5.62-3.35-7,.37-6.58-2.77,5.38-2,3.7-5c-1.85-3.23.57-5.43,3.64-5.09s1.85-2.57,5.06-3.7c5.55-1.94,3.41,6.52,7.28,4.72C173,343.82,177.15,348,172.22,350.48Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      transformOrigin: "162.626px 350.119px"
    },
    className: "animable",
    id: "elzokoij7tg6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M138.32,378.4c3.7-2.86.68-11.95,6.77-11.15s2.9-5.39,9.17-6,2.76,7.38,8.22,4.18,11-.24,10,5-8.13,3.43-5.75,8.06c2.61,5.09-1.52,9-6.43,8.84s-3,4-8.54,5.49c-7.25,1.91-5.81-8.17-10.26-6.35S132.23,383.12,138.32,378.4Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "154.023px 377.139px"
    },
    id: "el39kfwxfqwy8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elzv3o3dx9nzm"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.32,378.4c3.7-2.86.68-11.95,6.77-11.15s2.9-5.39,9.17-6,2.76,7.38,8.22,4.18,11-.24,10,5-8.13,3.43-5.75,8.06c2.61,5.09-1.52,9-6.43,8.84s-3,4-8.54,5.49c-7.25,1.91-5.81-8.17-10.26-6.35S132.23,383.12,138.32,378.4Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      transformOrigin: "154.023px 377.139px"
    },
    className: "animable",
    id: "elrve8xw16l88"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M140.91,378c5.41-3.15-.11-10,5.05-9.34s3.39-5.93,8.45-5.16,3.73,7.85,7.35,4.07,9.61-1.25,8.72,3.17-7.54,3.42-5.53,7.34c2.22,4.31-1.29,7.64-5.44,7.49s-2.78,3.79-7.26,5.69c-7.77,3.3-4-8.73-9.49-5.81C139.16,387.35,133.93,382,140.91,378Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "154.021px 377.638px"
    },
    id: "el997u7fpx2o4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el384ohcjiztt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.4,377.71c4.7-2.55.23-8.58,4.59-7.87s3.06-5,7.33-4.21,2.91,6.82,6.1,3.67,8.19-.83,7.29,2.94-6.5,2.74-4.91,6.15c1.74,3.75-1.34,6.51-4.86,6.28s-2.48,3.17-6.34,4.69c-6.69,2.63-3.15-7.58-7.87-5.22C140.62,385.7,136.35,381,142.4,377.71Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      transformOrigin: "153.579px 377.676px"
    },
    className: "animable",
    id: "el56sth54dljg"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el0ejc46zx60a4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.85,349.39v7.09a38.89,38.89,0,0,0,38.78,38.78h0a38.89,38.89,0,0,0,38.78-38.78v-7.09Z",
    style: {
      fill: "#1AB1AD",
      opacity: 0.3,
      transformOrigin: "142.63px 372.325px"
    },
    className: "animable",
    id: "ele1zgwwgwvt6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elufj5xhqcnat"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.36,349.39H102.9a2.25,2.25,0,0,1-2.24-2.24h0a2.25,2.25,0,0,1,2.24-2.24h79.46a2.25,2.25,0,0,1,2.24,2.24h0A2.25,2.25,0,0,1,182.36,349.39Z",
    style: {
      fill: "#1AB1AD",
      opacity: 0.5,
      transformOrigin: "142.63px 347.15px"
    },
    className: "animable",
    id: "elul45ge8aj7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el8tyvd1inl3"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.56,
    cy: 373.35,
    rx: 11.72,
    ry: 21.38,
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      transformOrigin: "127.56px 373.35px",
      transform: "rotate(-49.03deg)"
    },
    className: "animable",
    id: "elkz3tlhvpka"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elxqbsmhgzgmd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.19,374c-3,1.31-6.75-.66-8.39-4.41s-.55-7.84,2.45-9.15,6.75.66,8.39,4.4S156.18,372.64,153.19,374Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      transformOrigin: "150.219px 367.22px"
    },
    className: "animable",
    id: "eltz8enzgpp2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el191vmh50dzli"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420.33,354.86H383.22L387,392.92a2.59,2.59,0,0,0,2.58,2.34H414a2.59,2.59,0,0,0,2.58-2.34Z",
    style: {
      fill: "#1AB1AD",
      opacity: 0.3,
      transformOrigin: "401.775px 375.06px"
    },
    className: "animable",
    id: "el1z947p7xmd9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elvn8kv0xtml"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M390.41,386.9l-2.77-28s7.33,4.3,14.43,2.21a59,59,0,0,1,13.85-2.21l-2.78,28a4.84,4.84,0,0,1-4.82,4.36H395.23A4.85,4.85,0,0,1,390.41,386.9Z",
    style: {
      fill: "#1AB1AD",
      opacity: 0.3,
      transformOrigin: "401.78px 375.08px"
    },
    className: "animable",
    id: "elfxm5lpnrtv"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elgm1yx29f6ua"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M401.48,361.07a58.88,58.88,0,0,0-13.84-2.21s7.13,4.17,14.14,2.28Z",
    style: {
      fill: "#1AB1AD",
      opacity: 0.5,
      transformOrigin: "394.71px 360.246px"
    },
    className: "animable",
    id: "el6gjxe7kdc4y"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eleeeby1osdh7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420.77,355.86h-38a1.45,1.45,0,0,1-1.44-1.36l-.93-16.93a1.44,1.44,0,0,1,1.43-1.52H421.7a1.45,1.45,0,0,1,1.44,1.52l-.94,16.93A1.44,1.44,0,0,1,420.77,355.86Z",
    style: {
      fill: "#1AB1AD",
      opacity: 0.3,
      transformOrigin: "401.77px 345.955px"
    },
    className: "animable",
    id: "elxxtrbbpqgmj"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.85,279.79c.43,9.86-15.13,32.65,4.08,45.86,2.26,19.91,5.09,39.51,10.4,72.16H322.57c-4.12-28.24-3.22-60.42,10-124a25.33,25.33,0,0,0-22.26-30.39c-4-.4-8.24-.74-12.58-1-16.86-.81-30.69-1.35-45.52,0-4.91.45-10,1.07-14.84,1.75A34.41,34.41,0,0,0,207.85,279.79Z",
    style: {
      fill: "none"
    }
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0000",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorysetEatingHealthyFood31398);
export default __webpack_public_path__ + "static/media/storyset_eating_healthy_food_31398.8a4ccb033da4c9fb0d28ff93a3cf6d99.svg";
export { ForwardRef as ReactComponent };